// import external dependencies
// import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import homepage from './routes/homepage';
import planimetrie from './routes/planimetrie';
import landing from './routes/landing';
import newLanding from './routes/new-landing';
import blog from './routes/balance';
import life from './routes/life';
import work from './routes/work';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    homepage,
    // Planimetrie
    planimetrie,
    life,
    work,
    // Landing
    landing,
    newLanding,
    // Balance
    blog,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js